import { TFunction } from "i18next";

import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model["additionalFields"],
	t?: TFunction,
): string => {
	if (!item || !t) return "";

	const taximeter = item?.taximeter;
	const rateSettings = item?.rateSettings ?? {};

	const rateSettingTypes = Object.keys(rateSettings).filter(
		(type) => rateSettings[type],
	);

	if (taximeter) {
		rateSettingTypes.push("taximeter");
	}

	return rateSettingTypes
		.map((type) =>
			type === "taximeter"
				? t(
						"pages.mainPage.pages.orders.orderModal.orderRideInformation.str207",
				  )
				: t(`order_rate_setting.${type}`),
		)
		.join(", ");
};

export default cellProcessing;
